(function () {
  // Show/hide footer disclaimer
  var footerDisclaimer = document.querySelector(".footer-disclaimer");
  var footerDisclaimerButtons = document.querySelectorAll(
    ".footer-disclaimer-button"
  );
  if (!footerDisclaimer || !footerDisclaimerButtons) return;
  footerDisclaimerButtons.forEach((btn) =>
    btn.addEventListener("click", () =>
      footerDisclaimer.classList.toggle("footer-disclaimer-active")
    )
  );
})();

class BISTrigger extends HTMLElement {
  constructor() {
    super();
  }

  fetchFormContent() {
    var variant_id =
    this.getAttribute("data-variant-id") ||
    this.closest('form [name="id"]').value;
  this.product_handle = this.getAttribute("data-product-handle");

    var section_id = "async-bis-modal-form";
    fetch(Shopify.routes.root + "products/" + this.product_handle + "?sections=" + section_id)
      .then((res) => res.json())
      .then((json) => {
        var items = json[section_id];
        var parsed_dom = new DOMParser().parseFromString(items, "text/html");
        var form_bis = parsed_dom.querySelector("#form-bis-modal");

        return form_bis;
      })
      .then((form_bis) => {
        this.dispatchEvent(
          new CustomEvent("bis:trigger:click", {
            detail: {
              variant_id: variant_id,
              form_bis: form_bis,
            },
            bubbles: true,
          })
        );
      });
  }

  connectedCallback() {
    this.addEventListener("click", () => {
      this.fetchFormContent();
    });
  }
}

customElements.define("bis-trigger", BISTrigger);
